export interface ObservationItem {
  price: string;
  list_price?: string | null;
  currency?: string | null;
  recorded_at: string;
  discount_pct?: number | null;
}

export interface PriceStats {
  currentPrice: number;
  lowestPrice: number;
  highestPrice: number;
  firstPrice: number;
  totalDropPct: number;
  observationCount: number;
}

export function calculatePriceStats(observations: ObservationItem[]): PriceStats {
  if (!observations || observations.length === 0) {
    return {
      currentPrice: 0,
      lowestPrice: 0,
      highestPrice: 0,
      firstPrice: 0,
      totalDropPct: 0,
      observationCount: 0,
    };
  }

  // Parse chronological numbers
  const prices = observations.map((o) => parseFloat(o.price)).filter((p) => !isNaN(p));
  if (prices.length === 0) {
    return {
      currentPrice: 0,
      lowestPrice: 0,
      highestPrice: 0,
      firstPrice: 0,
      totalDropPct: 0,
      observationCount: 0,
    };
  }

  const firstPrice = prices[0]!;
  const currentPrice = prices[prices.length - 1]!;
  const lowestPrice = Math.min(...prices);
  const highestPrice = Math.max(...prices);

  const totalDropPct =
    prices.length > 1 && firstPrice > 0
      ? ((currentPrice - firstPrice) / firstPrice) * 100
      : 0;

  return {
    currentPrice,
    lowestPrice,
    highestPrice,
    firstPrice,
    totalDropPct,
    observationCount: observations.length,
  };
}

export function filterObservationsByRange(
  observations: ObservationItem[],
  range: '30d' | '90d' | 'all'
): ObservationItem[] {
  if (range === 'all' || !observations) return observations;

  const days = range === '30d' ? 30 : 90;
  const cutoff = Date.now() - days * 24 * 60 * 60 * 1000;

  return observations.filter((o) => {
    const time = new Date(o.recorded_at).getTime();
    return !isNaN(time) && time >= cutoff;
  });
}
